import { type MetaFunction } from '@remix-run/react'
import { brandName } from '#app/components/branding.js'
import { type loader as reactionsLoader } from './reactions.tsx'

export default function ReactionsIndexRoute() {
	return (
		<div className="rounded-xl border bg-muted/30 p-6 text-center">
			<p className="text-sm text-muted-foreground">Select a reaction type above to see activity</p>
		</div>
	)
}

export const meta: MetaFunction<
	null,
	{ 'routes/users+/$username_+/reactions': typeof reactionsLoader }
> = ({ params, matches }) => {
	const match = matches.find((m) => m.id === 'routes/users+/$username_+/reactions')
	const displayName = match?.data?.owner.name ?? params.username
	const count = match?.data?.owner.Reaction.length ?? 0
	return [
		{ title: `${displayName}'s Reactions | ${brandName}` },
		{ name: 'description', content: `${displayName}'s ${count} reaction${count !== 1 ? 's' : ''} on ${brandName}` },
	]
}
